type Props = { fullscreen?: boolean; label?: string };

export function Spinner({ fullscreen = false, label }: Props) {
  const inner = (
    <div className="flex items-center gap-3 text-nb-text">
      <span
        aria-hidden
        className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-slate-500 border-t-nb-mint"
      />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
  if (fullscreen) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="flex h-dvh w-dvw items-center justify-center bg-nb-bg"
      >
        {inner}
      </div>
    );
  }
  return (
    <div role="status" aria-live="polite">
      {inner}
    </div>
  );
}